import Sheet from "./sheet";

export default function PrivacyLink() {
  return (
    <Sheet
      trigger={<span className="underline">We never store your data</span>}
    >
      <div className="p-4 text-lg space-y-4 text-gray-900">
        <p>
          All the processing of your Instagram data happens on this device and
          your Instagram data is never uploaded to a server. Your Instagram data
          is never stored anywhere and stays fully private, so Locket has no way
          to acccess your data.
        </p>
        <p>
          Anonymous device and usage data (like crash reports and device
          diagnostics) may be collected in order to monitor and improve the
          website.
        </p>
      </div>
    </Sheet>
  );
}
